import { render, staticRenderFns } from "./SingleHeader.vue?vue&type=template&id=013ffcbe&scoped=true&"
import script from "./SingleHeader.vue?vue&type=script&lang=js&"
export * from "./SingleHeader.vue?vue&type=script&lang=js&"
import style0 from "./SingleHeader.vue?vue&type=style&index=0&id=013ffcbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013ffcbe",
  null
  
)

export default component.exports